module.exports = __webpack_public_path__ + "static/media/cleaning_before_checkout.84c0bfb1.svg";